export class StatusType {
    static Canceled = 'Canceled';
    static Closed = 'Closed';
    static Pending = 'Pending';
    static Resolved = 'Resolved';
    static Escalated = 'Escalated';
    static InProgress = 'In Progress';
    static WaitingForCustomer = 'Waiting for customer';
    static WaitingForSupport = 'Waiting for support';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/issue-type.ts